<script setup>
import { formatDuration } from "../../lib/modules/time.js";
import { useEvent, useFetch } from "vutil";

const props = defineProps(["id"]);

const monthFmt = new Intl.DateTimeFormat("nb-NO", { year: "numeric", month: "long" });
const dateFmt  = new Intl.DateTimeFormat("nb-NO", { weekday: "short", day: "numeric", hour: "numeric", minute: "numeric" });
const numbFmt  = new Intl.NumberFormat("nb-NO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const { data, error, get } = useFetch(`/api/site/${props.id}/sessions`, data =>
{
	const map = new Map();

	for (const sess of data) {
		const key = sess.year + "-" + sess.month;
		let month = map.get(key);

		if (!month) {
			month = { month: monthFmt.format(new Date(sess.year, sess.month - 1)), amount: 0, fee: 0, sessions: [] };
			map.set(key, month);
		}

		month.amount += sess.amount;
		month.fee += sess.fee;
		month.sessions.push(sess);
	}

	return map;
});

useEvent(document, "visibilitychange", () => !document.hidden && get());
</script>

<template>
	<div class="error">{{ error }}</div>
	<template v-if="data">
		<div v-if="data.size === 0" class="list">
			<div>Ingen historikk registrert</div>
		</div>
		<a v-else :href="`/api/site/${id}/session-export`" style="float: right">CSV export</a>
		<template v-for="[key, month] in data" :key="key">
			<h2>{{ month.month }}</h2>
			<table class="ui dense">
				<thead>
					<tr>
						<th style="width: 41%">Start</th>
						<th style="width: 16%" class="right">Tid</th>
						<th style="width: 16%" class="right">kWh</th>
						<th style="width: 27%" class="right">Beløp</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="sess in month.sessions" :key="sess.id" :title="sess.sn">
						<td>{{ dateFmt.format(sess.started * 1000) }}</td>
						<td class="right">{{ formatDuration(sess.duration) }}</td>
						<td class="right">{{ numbFmt.format(sess.energy / 1000) }}</td>
						<td class="right">{{ numbFmt.format(sess.amount / 100) }}</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<td class="right" colspan="3">Sum ZEV-omsetning</td>
						<td class="right">{{ numbFmt.format(month.amount / 100) }}</td>
					</tr>
					<tr class="no-border">
						<td class="right" colspan="3">ZEV-kostnad (15 %)</td>
						<td class="right">{{ numbFmt.format(-month.fee / 100) }}</td>
					</tr>
					<tr class="no-border">
						<td class="right" colspan="3">Deres vederlag</td>
						<td class="right">{{ numbFmt.format((month.amount - month.fee) / 100) }}</td>
					</tr>
				</tfoot>
			</table>
		</template>
	</template>
</template>
